import axios from "../http";

class ProjectManage {
  // 项目列表
  getProjectList(currentPage, warehouseId, projectName, status) {
    const url = `/oa/api/project/page?currentPage=${currentPage}&warehouseId=${warehouseId}&projectName=${projectName}&status=${status}`;
    return axios(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //负责人列表
  getEmployeeList() {
    const url = `/oa/api/employee/list`;
    return axios(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增项目
  postAddProject(data) {
    const url = `/oa/api/project/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //项目详情
  getProjectDetail(id) {
    const url = `/oa/api/project/detail?id=${id}`;
    return axios(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //修改项目
  postUpdateProject(data) {
    const url = `/oa/api/project/modify`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增客户
  postAddCustomer(data) {
    const url = `/oa/api/customer/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //关闭项目
  getCloseProject(id) {
    const url = `/oa/api/project/close?id=${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 客户列表
  getCustomerList(pageNo, queryStr) {
    const url = `/oa/api/customer/page?pageNo=${pageNo}&queryStr=${queryStr}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开启客户
  postOpenCustomerAccount(id) {
    const url = `/oa/api/customer/update/status/on/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 关闭客户
  postCloseCustomerAccount(id) {
    const url = `/oa/api/customer/update/status/off/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 面积导入
  postExcel(data) {
    const url = `/oa/api/upload/use/area`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 服务名称列表
  getServiceNameList() {
    const url = `/oa/api/project/get/extra/service/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ProjectManage;
